import { Dayjs } from 'dayjs';

import { RecordString } from '../../../../types/record.type';

export enum IUserFormTab {
  professional = 'professional',
  cv = 'cv',
}

export type IUserForm = RecordString<
  | 'firstname'
  | 'lastname'
  | 'email'
  | 'phone'
  | 'linkedin'
  | 'address'
  | 'address_secondary'
  | 'postalcode'
  | 'city'
  | 'country'
  | 'email_secondary'
  | 'phone_professional'
  | 'cv'
  | 'cv_fr'
> &
  Record<'birthday' | 'date_available', Dayjs | null> & {
    available: number;
  };

export type IUserFormRequest = Omit<IUserForm, 'birthday' | 'date_available'> &
  RecordString<'birthday' | 'date_available'>;

export enum ICvType {
  en = 'en',
  fr = 'fr',
}
